import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    isOpen: false,
    count: 0,
    type: "",
    rowInfo: -1
  };
  
  const dialogBuildingSlice = createSlice({
    name: 'dialogBuildingSlice',
    initialState,
    reducers: {
      openDialogBuilding: (state, { payload }) => {
        return {
          ...state,
          isOpen: true,
          count: state.count + 1,
          type: payload.type,
          rowInfo: payload.rowInfo
        };
      },
      closeDialogBuilding: (state) => {
        return {
          ...state,
          isOpen: false,
          count: 0,
          type: "",
          rowInfo: -1
        };
      }
    }
  });

export const { openDialogBuilding,closeDialogBuilding} = dialogBuildingSlice.actions;

const { reducer } = dialogBuildingSlice;

export default reducer;